export enum UniSectionHeaderSize {
    default = 'default',
    small = 'small',
    medium = 'medium',
    grid = 'grid',
};
